import { CommentDistributionGraph } from "@pages/VideoAnalytics/RBTs/GraphAndrawData/CommentDistribution/CommentDistributionGraph";
import { CommentDistributionRawData } from "@pages/VideoAnalytics/RBTs/GraphAndrawData/CommentDistribution/CommentDistributionRawData";
import { useVideoAnalytics } from "@providers/VideoAnalyticsProvider";

interface CommentDistributionProps {
  isCommentDistributionWithCommentType: boolean;
}
export const CommentDistribution: React.FC<CommentDistributionProps> = ({ isCommentDistributionWithCommentType }) => {
  const { selectedDialogTab } = useVideoAnalytics();
  return (
    <div>
      {selectedDialogTab === "Raw Data" ? (
        <CommentDistributionRawData isCommentDistributionWithCommentType={isCommentDistributionWithCommentType} />
      ) : (
        <CommentDistributionGraph />
      )}
    </div>
  );
};
